import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { LoginForm } from '@/components/auth/login-form'
import { ReactElement } from 'react'
import AuthLayout from '@/components/auth/auth-layout'

const Login = () => {
  return <LoginForm />
}

Login.getLayout = function getLayout(page: ReactElement) {
  return <AuthLayout title="login">{page}</AuthLayout>
}

export default Login

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'auth'])),
    },
  }
}
